import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useRouteMatch } from "react-router-dom";
import { Pivot, PivotSetupForm } from "../../dtos/pivot";
import { usePivots } from "../../hooks/usePivots";
import { AddPivotModal, pivotToSetupForm } from "./addPivotModal";
import { PivotDetailsPanel } from "./PivotDetailsPanel";

const PivotPage = () => {
  const match = useRouteMatch<{ pivotId: string | undefined }>();
  const pivotId = match.params.pivotId ? parseInt(match.params.pivotId, 10) : 0;
  const { pivots, updatePivot } = usePivots();
  const pivot = pivots.find(p => p.id === pivotId) ?? null;
  const classes = useStyles();
  const [editModalOpen, setEditModalOpen] = useState(false);

  const initialForm = useMemo(() => (pivot ? pivotToSetupForm(pivot) : null), [pivot]);
  const pivotSetupData = useMemo(() => {
    if (!pivot) {
      return null;
    }

    return {
      endGunSections: pivot.end_gun_sections ?? []
    };
  }, [pivot]);

  if (!pivot) {
    return <Typography>Pivot not found.</Typography>;
  }

  const handleSave = (form: PivotSetupForm) => {
    const updatedPivot: Pivot = {
      ...pivot,
      name: form.name,
      serial: form.serial,
      length: form.length_ft,
      description: form.description,
      lat: form.center_lat ?? undefined,
      lon: form.center_lon ?? undefined,
      pivot_type: form.pivot_type,
      travel_direction: form.travel_direction,
      speed_percent: form.speed_percent,
      limit_angle_a: form.limit_angle_a,
      limit_angle_b: form.limit_angle_b,
      limit_a_action: form.limit_a_action,
      limit_b_action: form.limit_b_action,
      end_gun_enabled: form.end_gun_enabled,
      end_gun_sections: form.end_gun_sections,
      pump_ids: form.pump_ids,
      valve_ids: form.valve_ids
    };

    updatePivot(updatedPivot);
  };

  return (
    <div className={classes.root}>
      <AddPivotModal
        isVisible={editModalOpen}
        onSave={handleSave}
        close={() => setEditModalOpen(false)}
        initialForm={initialForm}
        title="Edit Pivot"
        submitLabel="Save Pivot"
      />
      <PivotDetailsPanel
        pivot={pivot}
        configuredEndGunSections={pivotSetupData?.endGunSections ?? []}
        onEditPivot={() => setEditModalOpen(true)}
      />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: theme.spacing(2)
  }
}));

export default PivotPage;
